<template>
    <div>
		<div class="row mt-5">
			<div class="col-lg-4 offset-lg-4 col-md-6 offset-md-3">
				<alert-success :form="form" :class="'d-block shadow-sm'" message="Transactions uploaded successfully!"></alert-success>
			</div>
		</div>
		<div class="row">
			<div class="col-lg-4 offset-lg-4 col-md-6 offset-md-3">
				<div class="d-flex flex-column align-items-center justify-content-center">
					<div class="justify-content-center">
						<div class="wd-150 wd-sm-150 mg-b-30">
							<img :src="documentCsv"  class="img-fluid" alt="">
						</div>
					</div>

					<h3 class="tx-color-01 mg-b-5 tx-center">Upload Transactions</h3>
					<p class="tx-color-03 tx-13">File to be uploaded must be a csv file and dates must be in this format YYYY-MM-DD.</p>

					<form class="wd-100p" enctype="multipart/form-data" @submit.prevent="upload">
						<div class="form-group">
							<label class="wd-100p">File <a href="/storage/templates/transactions-template.csv" class="tx-12 float-right">Download Template</a></label>
							<div class="custom-file">
								<input type="file" class="form-control shadow-sm" :class="{ 'is-invalid': form.errors.has('file') }" name="file" accept=".csv" id="file" @change="selectFile" required>
								<label class="custom-file-label" for="file" aria-describedby="file">Choose file</label>
							</div>
							<has-error :form="form" field="file"></has-error>
						</div>
						<button-component :busy="form.busy" :label="'Upload'" :label-loading="'Please wait...'" :button-class="'btn btn-default btn-block shadow-sm mg-b-5 mg-sm-b-0'"></button-component>
					</form>
				</div>
			</div>
		</div>
    </div>
</template>

<script>
	const objectToFormData = require("../../../../../js/scripts/objectToFormData");
	import documentCsv from '../../../../../img/document-csv.svg'

	export default {
		data() {
			return {
				documentCsv,
				form: new Form({
					file: null
				})
			};
		},
		methods: {
			selectFile(e) {
				const file = e.target.files[0];
				const type = e.target.id;

				this.form.file = file;
			},
			upload() {
				this.form
					.submit("post", "/api/transactions", {
						transformRequest: [
							function(data, headers) {
								return objectToFormData(data);
							}
						]
					})
					.then(({ data }) => {
						$(".custom-file-label").html("Choose file");
						this.form.reset();
					});
			}
		}
	};
</script>